import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../components/fonts/font-props";
import { PlanStore } from "../../../../subscription-plans/stores/subscription-plans-store";
import OnboardingPlanPricing from "./onboarding-plan-pricing";
import "./onboarding-plan-header.scss";
import OnboardingPlanShortDescription from "../onboarding-plan-short-description/onboarding-plan-short-description";
import FontBody1 from "../../../../../components/fonts/font-body1/font-body1";

interface IProps {
    plan: PlanStore;
}

const OnboardingPlanHeader: React.FC<IProps> = (({plan}) => {
    
    return (
        <div className="onboarding-plan-header">
            <div className="onboarding-plan-header-title">
                <FontBody1 color={FONT_COLOR.NEUTRAL_WHITE} variant={FONT_VARIANT.BOLD}>
                    {plan.name}
                </FontBody1>
            </div>

            <div className="onboarding-plan-header-short-description">
                <OnboardingPlanShortDescription plan={plan}/>
            </div>

            <div className="onboarding-plan-header-pricing-title">
                <OnboardingPlanPricing plan={plan}/>
            </div>

            <div className="onboarding-plan-header-pricing-subtitle">
                <FontBody2 color={FONT_COLOR.NEUTRAL3} variant={FONT_VARIANT.BOLD}>
                    {plan.formattedPricePerExtraRma}{'\u00A0'}
                </FontBody2>
                <FontBody2 color={FONT_COLOR.NEUTRAL3}>
                    per extra return
                </FontBody2>
            </div>
        </div>
    );
});

export default OnboardingPlanHeader;